/**
 * The one copy-routing rule for package cards, shared by the Offerings
 * section and the Services mega menu: website/ios read marketing-voice copy
 * from `offerings.items.*`, while Custom (which has no offerings entry)
 * reuses its `pricing.tiers.custom` copy.
 */
import { useTranslations } from "next-intl";
import type { PackageKey } from "@/lib/brand";

export interface PackageCopy {
  readonly title: string;
  readonly detail: string;
  readonly include: (index: string) => string;
}

/** Returns a resolver mapping a package key to its display copy. */
export function usePackageCopy(): (key: PackageKey) => PackageCopy {
  const t = useTranslations("offerings");
  const tPricing = useTranslations("pricing");
  return (key) =>
    key === "custom"
      ? {
          title: tPricing("tiers.custom.name"),
          detail: tPricing("tiers.custom.tagline"),
          include: (index) => tPricing(`tiers.custom.features.${index}`),
        }
      : {
          title: t(`items.${key}.title`),
          detail: t(`items.${key}.outcome`),
          include: (index) => t(`items.${key}.includes.${index}`),
        };
}
